import { computed, ref, watch, onMounted, onBeforeUnmount } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1b8a6272"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "table-content"
};
const _hoisted_2 = {
  class: "download-btn-wrap"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = ["onClick"];
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  key: 3,
  class: "handle-content"
};
const _hoisted_7 = {
  key: 0,
  style: {
    "margin-right": "16px"
  }
};
const _hoisted_8 = {
  key: 4,
  class: "amount-wrap"
};
const _hoisted_9 = {
  key: 0,
  class: "handle-content"
};
const _hoisted_10 = {
  class: "expand-content"
};
const _hoisted_11 = {
  class: "time-line-content"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "title-label"
}, "订单创建时间", -1));
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "title-label"
}, "退款发起时间", -1));
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "title-label"
}, "退款完成时间", -1));
const _hoisted_15 = {
  class: "info-content"
};
const _hoisted_16 = {
  class: "info-list"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "三方平台订单号：", -1));
const _hoisted_18 = {
  class: "value"
};
const _hoisted_19 = {
  class: "info-list"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "内购ID：", -1));
const _hoisted_21 = {
  class: "value"
};
import { message } from 'ant-design-vue';
import { awaitWrap, OK, reportEvent } from '@/common';
import { Modal } from 'ant-design-vue';
// import { Revenue } from '@/types/revenue'
import OrderModal from '@/views/orderManage/orderList/components/OrderModal.vue';
import { exportOrderList, queryRefundList, retryRefundApi, queryOrderListV2 } from '@/api/orderApi';
import { useStore } from '@/store';
import OrderDrawer from '@/views/orderManage/orderList/components/OrderDrawer.vue';
import dayjs from 'dayjs';
import useFilterHeader from '../../newOrderList/components/useFilterHeader';
import OrderDetail from '@/views/orderManage/orderList/components/OrderDetail.vue';
import { copy } from '@/common';
export default /*#__PURE__*/_defineComponent({
  __name: 'RefundTableBlock',
  props: {
    tableType: null
  },
  emits: ['updateLoading'],
  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    _useCssVars(_ctx => ({
      "62328cac": slotheight.value,
      "7344d31c": tableMinHeight.value
    }));
    const payStatusList = [{
      label: '全部',
      value: null
    }, {
      label: '未支付',
      value: '0'
    }, {
      label: '失败',
      value: '10'
    }, {
      label: '成功',
      value: '20'
    }, {
      label: '成功',
      value: '21'
    }, {
      label: '成功',
      value: '22'
    }, {
      label: '退款',
      value: '30'
    }];
    // const shipStatusList = [
    //   { label: '全部', value: null },
    //   { label: '失败', value: '0' },
    //   { label: '成功', value: '10' },
    //   { label: '回收', value: '12' },
    // ]
    const {
      refundStatusList,
      shipStatusList
    } = useFilterHeader();
    const userInfo = computed(() => useStore().userInfo && JSON.parse(useStore().userInfo));
    const loading = ref(false);
    const columns = ref([{
      title: 'DBT订单号',
      dataIndex: 'orderNo',
      key: 'orderNo'
    }, {
      title: '内购ID',
      dataIndex: 'prodId',
      key: 'prodId'
    }, {
      title: '商品名称',
      dataIndex: 'prodName',
      key: 'prodName'
    }, {
      title: '价格',
      dataIndex: 'amount',
      key: 'amount'
    }, {
      title: '币种',
      dataIndex: 'currency',
      key: 'currency'
    }, {
      title: '设备ID',
      dataIndex: 'deviceId',
      key: 'deviceId'
    }, {
      title: '操作',
      dataIndex: 'handle',
      key: 'handle',
      align: 'right'
    }]);
    const columnsOrder = [{
      title: 'DBT订单号',
      dataIndex: 'orderNo',
      key: 'orderNo'
    }, {
      title: '三方订单号',
      dataIndex: 'platOrderNo',
      key: 'platOrderNo'
    }, {
      title: '设备ID',
      dataIndex: 'deviceId',
      key: 'deviceId'
    }, {
      title: '商品名称',
      dataIndex: 'prodName',
      key: 'prodName'
    }, {
      title: '金额',
      dataIndex: 'amount',
      key: 'amount'
    }, {
      title: '创建时间',
      dataIndex: 'createDate',
      key: 'createDate',
      width: 180
    }, {
      title: '支付时间',
      dataIndex: 'thirdPayTime',
      key: 'thirdPayTime',
      width: 180
    }, {
      title: '支付状态',
      dataIndex: 'payStatus',
      key: 'payStatus',
      width: 80,
      fixed: 'right'
    }, {
      title: '道具状态',
      dataIndex: 'shipStatus',
      key: 'shipStatus',
      width: 80,
      fixed: 'right'
    }, {
      title: '操作',
      dataIndex: 'handle',
      key: 'handle',
      align: 'right',
      fixed: 'right'
    }];
    const columnsReimburse = [{
      title: 'DBT订单号',
      dataIndex: 'orderNo',
      key: 'orderNo'
    }, {
      title: '商品名称',
      dataIndex: 'prodName',
      key: 'prodName'
    }, {
      title: '价格',
      dataIndex: 'amount',
      key: 'amount'
    }, {
      title: '退款金额',
      dataIndex: 'refundAmount',
      key: 'refundAmount'
    }, {
      title: '币种',
      dataIndex: 'refundCurrency',
      key: 'refundCurrency'
    }, {
      title: '设备ID',
      dataIndex: 'deviceId',
      key: 'deviceId'
    }, {
      title: '退款渠道',
      dataIndex: 'payChnl',
      key: 'payChnl'
    }, {
      title: '退款状态',
      dataIndex: 'refundStatus',
      key: 'refundStatus'
    }, {
      title: '操作',
      dataIndex: 'handle',
      key: 'handle',
      align: 'right'
    }];
    const orderRef = ref();
    const dataSource = ref([]);
    const pageIndex = ref(1);
    const pageSize = ref(20);
    const pageTotal = ref(0);
    const searchObj = ref({});
    const pageArrow = ref('1');
    const slotheight = ref(`${window.innerHeight - 220}px`);
    const tableheight = ref(`${window.innerHeight - (props.tableType === '1' ? 400 : 360)}px`);
    const tableMinHeight = ref(`${window.innerHeight - (props.tableType === '1' ? 350 : 310)}px`);
    const tableRef = ref();
    const drawVisible = ref(false);
    const refundItem = ref({});
    const isReadOnly = ref(false);
    const orderDetailRef = ref(null);
    const getData = async () => {
      var _dataSource$value;
      pageTotal.value = 0;
      //   if (!searchObj.value.dbtId) {
      //     dataSource.value = []
      //     return
      //   }
      let lastItem = {};
      if ((_dataSource$value = dataSource.value) !== null && _dataSource$value !== void 0 && _dataSource$value.length) {
        lastItem = pageArrow.value === '1' ? dataSource.value[dataSource.value.length - 1] : dataSource.value[0];
      }
      const params = {
        lastId: lastItem.id ? lastItem.id : '',
        lastOrderNo: lastItem.orderNo ? lastItem.orderNo : '',
        pageArrow: pageArrow.value,
        pageSize: pageSize.value,
        ...searchObj.value
      };
      await getDataSource(params);
    };
    const getReData = async () => {
      if (!searchObj.value.dbtId) return;
      const params = {
        ...searchObj.value,
        pageSize: pageSize.value,
        pageNum: pageIndex.value
      };
      loading.value = true;
      try {
        const [err, res] = await awaitWrap(queryRefundList(params));
        if (err) {
          return loading.value = false;
        }
        if (res) {
          loading.value = false;
          if (res.code === OK) {
            dataSource.value = res.data;
            pageTotal.value = res.count;
          } else {
            loading.value = false;
          }
        }
      } catch (err) {
        loading.value = false;
      }
    };
    const getDataSource = async params => {
      const startTime = new Date().getTime();
      loading.value = true;
      emit('updateLoading', true);
      try {
        const [err, res] = await awaitWrap(queryOrderListV2(params));
        if (err) {
          return loading.value = false;
        }
        if (res) {
          loading.value = false;
          pageTotal.value = res.count;
          dataSource.value = res.data;
          reportEvent({
            eventName: '_search',
            properties: {
              ui_name: '订单查询',
              app_name: '',
              return_duration: (new Date().getTime() - startTime) / 1000,
              query_status: 'succeed'
            }
          });
        } else {
          reportEvent({
            eventName: '_search',
            properties: {
              ui_name: '订单查询',
              app_name: '',
              return_duration: (new Date().getTime() - startTime) / 1000,
              query_status: 'failed'
            }
          });
        }
      } catch (e) {
        reportEvent({
          eventName: '_search',
          properties: {
            ui_name: '订单查询',
            app_name: '',
            return_duration: (new Date().getTime() - startTime) / 1000,
            query_status: 'failed'
          }
        });
      }
      loading.value = false;
      emit('updateLoading', false);
    };
    const searchData = async obj => {
      pageIndex.value = 1;
      searchObj.value = obj;
      dataSource.value = [];
      pageArrow.value = '1';
      if (props.tableType === '1') {
        await getData();
      } else {
        await getReData();
      }
    };
    const changePage = async (page, pageS) => {
      if (props.tableType === '1') {
        let lastItem = {};
        //是否修改pageSize
        if (pageSize.value !== pageS) {
          dataSource.value = [];
          pageArrow.value = '1';
          pageIndex.value = 1;
        } else {
          if (page > Number(pageIndex.value)) {
            pageArrow.value = '1';
          } else {
            pageArrow.value = '0';
          }
          pageIndex.value = page;
        }
        if (dataSource.value.length) {
          lastItem = pageArrow.value === '1' ? dataSource.value[dataSource.value.length - 1] : dataSource.value[0];
        }
        pageSize.value = pageS;
        const params = {
          // currentProject: pageIndex.value,
          lastId: lastItem.id ? lastItem.id : '',
          lastOrderNo: lastItem.orderNo ? lastItem.orderNo : '',
          pageArrow: pageArrow.value,
          pageSize: pageSize.value,
          ...searchObj.value
        };
        await getDataSource(params);
      } else {
        pageIndex.value = page;
        pageSize.value = pageS;
        await getReData();
      }
      // await getData()
    };
    const openDetail = async item => {
      // detailVisible.value = true
      orderRef === null || orderRef === void 0 || orderRef.value.showModal(item);
    };
    const updateList = () => {
      if (props.tableType === '1') {
        dataSource.value = [];
        pageArrow.value = '1';
        pageIndex.value = 1;
        getData();
      } else {
        dataSource.value = [];
        pageArrow.value = '1';
        pageIndex.value = 1;
        getReData();
      }
    };
    const handleDownload = () => {
      if (!searchObj.value.dbtId) {
        return;
      }
      if (!pageTotal.value) return message.warning('暂无数据');
      if (pageTotal.value > 1000) {
        Modal.confirm({
          title: '提示',
          centered: true,
          content: '仅支持下载前1000条数据!',
          onOk: () => {
            exportOrderList({
              ...searchObj.value
            }).then(res => {
              const url = window.URL.createObjectURL(res);
              const eleA = document.createElement('a');
              eleA.href = url;
              eleA.download = `${searchObj.value.appName}.xlsx`;
              eleA.click();
              window.URL.revokeObjectURL(url);
            }).catch(err => {});
            reportEvent({
              eventName: 'element_use',
              properties: {
                ui_name: '订单查询',
                element_name: '导出订单'
              }
            });
          }
        });
      } else {
        exportOrderList({
          ...searchObj.value
        }).then(res => {
          const url = window.URL.createObjectURL(res);
          const eleA = document.createElement('a');
          eleA.href = url;
          eleA.download = `${searchObj.value.appName}.xlsx`;
          eleA.click();
          window.URL.revokeObjectURL(url);
        }).catch(err => {});
        reportEvent({
          eventName: 'element_use',
          properties: {
            ui_name: '订单查询',
            element_name: '导出订单'
          }
        });
      }
    };
    const closeMore = bool => {
      if (!bool) {
        slotheight.value = `${window.innerHeight - 220}px`;
        tableheight.value = `${window.innerHeight - (props.tableType === '1' ? 400 : 360)}px`;
      }
    };
    const openDrawer = (item, readOnly = false, isEdit = false) => {
      isReadOnly.value = readOnly;
      refundItem.value = {
        ...item,
        isEdit
      };
      drawVisible.value = true;
    };
    const initRefund = () => {
      refundItem.value = {};
    };
    const handleShow = item => {
      return ['wxpay', 'jsapipay', 'alipay'].includes(item.payChnl) && dayjs(new Date()).diff(dayjs(item.createDate), 'day') <= 365 && (item.platStatus === '1' || item.clientPayStatus === '1');
    };
    const handleDisabled = item => {
      return !item.orderRefundId && item.orderType !== 2;
    };
    const retryRefund = async id => {
      try {
        const [err, data] = await awaitWrap(retryRefundApi({
          id
        }));
        if (err) return message.error(err);
        if (data) {
          if (data.code === OK) {
            message.success('提交成功');
            updateList();
          }
        }
      } catch (e) {}
    };
    const handleShowDetail = item => {
      orderDetailRef.value.open(item);
    };
    // const splitText = (text: string, num: number) => {
    //   return text ? text?.slice(0, num) + '\n' + text?.slice(num) : ''
    // }
    watch(() => props.tableType, async newVal => {
      if (newVal === '1') {
        columns.value = columnsOrder;
      } else if (newVal === '2') {
        columns.value = columnsReimburse;
      }
    }, {
      immediate: true
    });
    expose({
      searchData,
      closeMore
    });
    onMounted(() => {
      window.addEventListener('resize', () => {
        slotheight.value = `${window.innerHeight - 220}px`;
        tableheight.value = `${window.innerHeight - (props.tableType === '1' ? 400 : 360)}px`;
        tableMinHeight.value = `${window.innerHeight - (props.tableType === '1' ? 350 : 310)}px`;
      });
    });
    onBeforeUnmount(() => {
      window.removeEventListener('resize', () => {
        slotheight.value = `${window.innerHeight - 220}px`;
        tableheight.value = `${window.innerHeight - (props.tableType === '1' ? 400 : 360)}px`;
        tableMinHeight.value = `${window.innerHeight - (props.tableType === '1' ? 350 : 310)}px`;
      });
    });
    return (_ctx, _cache) => {
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_statistic = _resolveComponent("a-statistic");
      const _component_a_table = _resolveComponent("a-table");
      const _component_a_timeline_item = _resolveComponent("a-timeline-item");
      const _component_a_timeline = _resolveComponent("a-timeline");
      const _component_a_pagination = _resolveComponent("a-pagination");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [__props.tableType == '1' ? (_openBlock(), _createBlock(_component_a_button, {
        key: 0,
        onClick: handleDownload,
        class: "download-btn"
      }, {
        icon: _withCtx(() => [_createVNode(_component_svg_icon, {
          "icon-class": "export",
          "class-name": "download-icon"
        })]),
        default: _withCtx(() => [_createTextVNode(" 导出订单 ")]),
        _: 1
      })) : _createCommentVNode("", true)]), __props.tableType === '1' ? (_openBlock(), _createBlock(_component_a_table, {
        key: 0,
        bordered: "",
        columns: columns.value,
        "data-source": dataSource.value,
        "row-key": "id",
        pagination: false,
        ref_key: "tableRef",
        ref: tableRef,
        loading: loading.value,
        scroll: {
          y: tableheight.value,
          x: 1500
        },
        class: "new-order-table"
      }, {
        bodyCell: _withCtx(({
          column,
          record
        }) => {
          var _unref2, _payStatusList$filter, _unref$filter;
          return [column.dataIndex === 'orderNo' ? (_openBlock(), _createBlock(_component_a_tooltip, {
            key: 0
          }, {
            title: _withCtx(() => [_createTextVNode("点击复制订单号")]),
            default: _withCtx(() => [_createElementVNode("div", {
              style: {
                "word-break": "break-all",
                "cursor": "pointer"
              },
              class: "order-copy-value",
              onClick: $event => _unref(copy)(record[column.dataIndex])
            }, _toDisplayString(record[column.dataIndex]), 9, _hoisted_3)]),
            _: 2
          }, 1024)) : _createCommentVNode("", true), column.dataIndex === 'platOrderNo' ? (_openBlock(), _createBlock(_component_a_tooltip, {
            key: 1
          }, {
            title: _withCtx(() => [_createTextVNode("点击复制三方订单号")]),
            default: _withCtx(() => [_createElementVNode("div", {
              style: {
                "word-break": "break-all",
                "cursor": "pointer"
              },
              class: "order-copy-value",
              onClick: $event => _unref(copy)(record[column.dataIndex])
            }, _toDisplayString(record[column.dataIndex]), 9, _hoisted_4)]),
            _: 2
          }, 1024)) : _createCommentVNode("", true), column.dataIndex === 'deviceId' ? (_openBlock(), _createBlock(_component_a_tooltip, {
            key: 2
          }, {
            title: _withCtx(() => [_createTextVNode("点击复制设备ID")]),
            default: _withCtx(() => [_createElementVNode("div", {
              style: {
                "word-break": "break-all",
                "cursor": "pointer"
              },
              class: "order-copy-value",
              onClick: $event => _unref(copy)(record[column.dataIndex])
            }, _toDisplayString(record[column.dataIndex]), 9, _hoisted_5)]),
            _: 2
          }, 1024)) : _createCommentVNode("", true), column.dataIndex === 'handle' ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_a_button, {
            type: "link",
            style: {
              "margin-right": "16px"
            },
            onClick: $event => handleShowDetail(record)
          }, {
            default: _withCtx(() => [_createTextVNode("详情")]),
            _: 2
          }, 1032, ["onClick"]), handleShow(record) ? (_openBlock(), _createElementBlock("div", _hoisted_7, [handleDisabled(record) ? (_openBlock(), _createBlock(_component_a_button, {
            key: 0,
            type: "link",
            onClick: $event => openDrawer(record, false, false)
          }, {
            default: _withCtx(() => [_createTextVNode(" 退款 ")]),
            _: 2
          }, 1032, ["onClick"])) : (_openBlock(), _createBlock(_component_a_tooltip, {
            key: 1
          }, {
            title: _withCtx(() => [_createTextVNode("该订单已进行退款操作")]),
            default: _withCtx(() => [_createVNode(_component_a_button, {
              type: "link",
              disabled: ""
            }, {
              default: _withCtx(() => [_createTextVNode("退款")]),
              _: 1
            })]),
            _: 1
          }))])) : _createCommentVNode("", true), _createVNode(_component_a_button, {
            type: "link",
            onClick: $event => openDetail(record),
            disabled: Number(record.orderType) == 2
          }, {
            default: _withCtx(() => [_createTextVNode("复送")]),
            _: 2
          }, 1032, ["onClick", "disabled"])])), [[_directive_permission, {
            permissionValue: 'orderList',
            permissionArr: (_unref2 = _unref(userInfo)) === null || _unref2 === void 0 ? void 0 : _unref2.permissions
          }]]) : _createCommentVNode("", true), column.dataIndex === 'amount' ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("span", null, _toDisplayString(record['currency']), 1), _createVNode(_component_a_statistic, {
            value: record['amount']
          }, null, 8, ["value"])])) : _createCommentVNode("", true), column.dataIndex === 'payStatus' ? (_openBlock(), _createElementBlock("span", {
            key: 5,
            class: _normalizeClass(["title-value", {
              success: record.payStatus == 20 || record.payStatus == 21 || record.payStatus == 22,
              error: record.payStatus == 10
            }])
          }, _toDisplayString((_payStatusList$filter = payStatusList.filter(item => item.value == record.payStatus)) === null || _payStatusList$filter === void 0 || (_payStatusList$filter = _payStatusList$filter[0]) === null || _payStatusList$filter === void 0 ? void 0 : _payStatusList$filter.label), 3)) : _createCommentVNode("", true), column.dataIndex === 'shipStatus' ? (_openBlock(), _createElementBlock("span", {
            key: 6,
            class: _normalizeClass(["title-value", {
              success: record.shipStatus == 10 || record.shipStatus == 12,
              error: record.shipStatus == 0
            }])
          }, _toDisplayString((_unref$filter = _unref(shipStatusList).filter(item => item.value == record.shipStatus)) === null || _unref$filter === void 0 || (_unref$filter = _unref$filter[0]) === null || _unref$filter === void 0 ? void 0 : _unref$filter.label), 3)) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["columns", "data-source", "loading", "scroll"])) : _createCommentVNode("", true), __props.tableType === '2' ? (_openBlock(), _createBlock(_component_a_table, {
        key: 1,
        bordered: "",
        columns: columns.value,
        "data-source": dataSource.value,
        "row-key": "id",
        pagination: false,
        ref_key: "tableRef",
        ref: tableRef,
        loading: loading.value,
        scroll: {
          y: tableheight.value
        }
      }, {
        bodyCell: _withCtx(({
          column,
          record
        }) => {
          var _unref3, _unref4, _unref$filter2;
          return [column.dataIndex === 'handle' ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_withDirectives((_openBlock(), _createElementBlock("div", null, [[31].includes(record.refundStatus) ? (_openBlock(), _createBlock(_component_a_button, {
            key: 0,
            type: "link",
            onClick: $event => retryRefund(record.id),
            style: {
              "margin-right": "16px"
            }
          }, {
            default: _withCtx(() => [_createTextVNode(" 重试 ")]),
            _: 2
          }, 1032, ["onClick"])) : _createCommentVNode("", true)])), [[_directive_permission, {
            permissionValue: 'refundList',
            permissionArr: (_unref3 = _unref(userInfo)) === null || _unref3 === void 0 ? void 0 : _unref3.permissions
          }]]), _withDirectives((_openBlock(), _createElementBlock("div", null, [[11, 12, 32].includes(record.refundStatus) ? (_openBlock(), _createBlock(_component_a_button, {
            key: 0,
            style: {
              "margin-right": "16px"
            },
            type: "link",
            onClick: $event => openDrawer(record, false, true)
          }, {
            default: _withCtx(() => [_createTextVNode(" 编辑 ")]),
            _: 2
          }, 1032, ["onClick"])) : _createCommentVNode("", true)])), [[_directive_permission, {
            permissionValue: 'refundList',
            permissionArr: (_unref4 = _unref(userInfo)) === null || _unref4 === void 0 ? void 0 : _unref4.permissions
          }]]), _createVNode(_component_a_button, {
            type: "link",
            onClick: $event => openDrawer(record, true)
          }, {
            default: _withCtx(() => [_createTextVNode("详情")]),
            _: 2
          }, 1032, ["onClick"])])) : _createCommentVNode("", true), column.dataIndex === 'refundStatus' ? (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: _normalizeClass(["title-value", {
              success: record.refundStatus == 40,
              error: [12, 11, 31, 32, 50].includes(Number(record.refundStatus))
            }])
          }, _toDisplayString(((_unref$filter2 = _unref(refundStatusList).filter(item => item.value === record.refundStatus)) === null || _unref$filter2 === void 0 || (_unref$filter2 = _unref$filter2[0]) === null || _unref$filter2 === void 0 ? void 0 : _unref$filter2.label) || '-'), 3)) : _createCommentVNode("", true)];
        }),
        expandedRowRender: _withCtx(({
          record
        }) => [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createVNode(_component_a_timeline, null, {
          default: _withCtx(() => [_createVNode(_component_a_timeline_item, null, {
            default: _withCtx(() => [_hoisted_12, _createElementVNode("span", null, _toDisplayString(record.orderCreateDate), 1)]),
            _: 2
          }, 1024), _createVNode(_component_a_timeline_item, null, {
            default: _withCtx(() => [_hoisted_13, _createElementVNode("span", null, _toDisplayString(record.createTime), 1)]),
            _: 2
          }, 1024), _createVNode(_component_a_timeline_item, null, {
            default: _withCtx(() => [_hoisted_14, _createElementVNode("span", null, _toDisplayString(record.refundDate), 1)]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1024)]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_hoisted_17, _createElementVNode("div", _hoisted_18, _toDisplayString(record.platOrderNo), 1)]), _createElementVNode("div", _hoisted_19, [_hoisted_20, _createElementVNode("div", _hoisted_21, _toDisplayString(record.prodId), 1)])])])]),
        _: 1
      }, 8, ["columns", "data-source", "loading", "scroll"])) : _createCommentVNode("", true), _createVNode(_component_a_pagination, {
        onChange: changePage,
        current: pageIndex.value,
        pageSize: pageSize.value,
        total: pageTotal.value,
        "show-total": total => `共 ${total} 条`
      }, null, 8, ["current", "pageSize", "total", "show-total"]), _createVNode(OrderModal, {
        onUpdateList: updateList,
        ref_key: "orderRef",
        ref: orderRef
      }, null, 512), _createVNode(OrderDrawer, {
        "is-read-only": isReadOnly.value,
        "modal-visible": drawVisible.value,
        "onUpdate:modal-visible": _cache[0] || (_cache[0] = $event => drawVisible.value = $event),
        "order-info": refundItem.value,
        onInitRefund: initRefund,
        onUpdateList: updateList
      }, null, 8, ["is-read-only", "modal-visible", "order-info"]), _createVNode(OrderDetail, {
        ref_key: "orderDetailRef",
        ref: orderDetailRef
      }, null, 512)]);
    };
  }
});